import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useMediaQuery } from 'react-responsive';

import { Collapsible } from '@spotahome/ui-library';

import ServicePlanHeader from './ServicePlanHeader';
import ServicePlanBody from './ServicePlanBody';

import './ServicePlan.scss';
import { servicePlansEnum } from './servicePlanConfig';

const MOBILE_MAX_WIDTH = 920;

const ServicePlan = ({ servicePlan, isCollapsed }) => {
  const servicePlanCx = classNames(
    'service-plan',
    `service-plan--${servicePlan}`
  );

  const isMobile = useMediaQuery({
    query: `(max-width: ${MOBILE_MAX_WIDTH - 1}px)`
  });

  const renderHeader = () => <ServicePlanHeader servicePlan={servicePlan} />;
  const renderBody = () => <ServicePlanBody servicePlan={servicePlan} />;

  const renderCollapsibleBody = () => <Fragment>{renderBody()}</Fragment>;

  const renderCollapsible = () => (
    <Collapsible
      className={servicePlanCx}
      headerClassName="service-plan__collapsible-header"
      hasIcon
      isCollapsed={isCollapsed}
      renderHeader={renderHeader}
      renderBody={renderCollapsibleBody}
    />
  );

  return isMobile ? (
    renderCollapsible()
  ) : (
    <div className={servicePlanCx} data-plan-type={servicePlan}>
      {renderHeader()}
      {renderBody()}
    </div>
  );
};

ServicePlan.propTypes = {
  servicePlan: PropTypes.oneOf(Object.values(servicePlansEnum)).isRequired,
  isCollapsed: PropTypes.bool
};

ServicePlan.defaultProps = {
  isCollapsed: false
};

export default ServicePlan;
